import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button, Row, Col, Card } from 'antd';

import { getConstants } from 'utils/apis/constants';
import { getUserProfileById } from 'utils/apis/user';
import { buildUserProfileSessionsUri } from 'utils/routes';

import { DEFAULT_USER_PROFILE_URL } from 'utils/constants';

import './UserProfileDisplay.css';
import intl from 'react-intl-universal';

const UserDetailsRow = ({ fieldName, value }) => (
  <Row gutter={{ sm: 24, xs: 16, span: 0 }} className="user-detail-row">
    <Col span={12} lg={8} className="user-detail-field-name">
      {fieldName}:
    </Col>
    <Col span={12} lg={16}>
      {value || '-'}
    </Col>
  </Row>
);

class UserProfileDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: '',
      nationality: ''
    };
  }

  componentWillMount() {
    getUserProfileById(this.props.id).then(res => {
      let nationality = res.data.userProfile && res.data.userProfile.nationality;
      getConstants('countries').then(resCountry => {
        if (resCountry && resCountry.status === 200) {
          Object.keys(resCountry.data).map(
            k =>
              resCountry.data[k].iso2 === nationality &&
              this.setState({
                nationality: intl.get(`countries.${resCountry.data[k].name.replace(/\./g, '_')}`).d(resCountry.data[k].name)
              })
          );
        } else {
          console.log('Error while retrieving country name');
        }
      });

      this.setState({
        name: res.data.username,
        email: res.data.email,
        firstName: res.data.userProfile ? res.data.userProfile.firstName : '',
        lastName: res.data.userProfile ? res.data.userProfile.lastName : '',
        contactNos: res.data.userProfile ? res.data.userProfile.contactNos : '',
        gender: res.data.userProfile ? (res.data.userProfile.gender === 1 ? 'Male' : 'Female') : '',
        identificationNo: res.data.userProfile ? res.data.userProfile.identificationNo : '',
        createdAt: res.data.userProfile ? res.data.userProfile.createdAt : '',
        imageUrl:
          res.data.userProfile && res.data.userProfile.displayPicture && res.data.userProfile.displayPicture.imageUrl
            ? res.data.userProfile.displayPicture.imageUrl
            : DEFAULT_USER_PROFILE_URL
      });
    });
  }

  constructName = (firstName, lastName) => {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    } else if (firstName || lastName) {
      return `${firstName || lastName}`;
    } else {
      return '-';
    }
  };

  render() {
    const { imageUrl, firstName, lastName, name, email, contactNos, gender, identificationNo, nationality } = this.state;

    return (
      <div>
        <Card className="user-profile-card">
          <Row>
            <Col span={24} lg={12}>
              <img src={imageUrl && imageUrl} alt="Profile Pic" className="user-profile-image" />
            </Col>
            <Col span={24} lg={12} className="user-details-col">
              <h3 className="user-profile-name">{this.constructName(firstName, lastName)}</h3>
              <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.username').d('Username')} value={name} />
              <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.email').d('Email')} value={email} />
              <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.firstName').d('First Name')} value={firstName} />
              <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.lastName').d('Last Name')} value={lastName} />
              <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.contact').d('Contact No')} value={contactNos} />
              {/* <UserDetailsRow fieldName="Gender" value={gender} /> */}
              {this.state.identificationNo && (
                <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.nric').d('NRIC/Passport Number')} value={identificationNo} />
              )}
              <UserDetailsRow fieldName={intl.get('userProfile.headerLabels.nationality').d('Nationality')} value={nationality} />
              <Row type="flex" justify="center" gutter={8} className="user-profile-buttons-row">
                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="user-profile-buttons">
                  <Link to={'/userProfile/' + this.props.id + '/edit'}>
                    <Button id="edit-button1-profile" type="primary" style={{ verticalAlign: 'bottom' }}>
                      {intl.get('userProfile.headerLabels.editProfile').d('Edit Profile')}
                    </Button>
                  </Link>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="user-profile-buttons">
                  <Link to={'/userProfile/' + this.props.id + '/resetpassword'}>
                    <Button id="pass-button1-profile" type="primary" style={{ verticalAlign: 'bottom' }}>
                      {intl.get('userProfile.headerLabels.reset').d('Reset Password')}
                    </Button>
                  </Link>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="user-profile-buttons">
                  <Link to={buildUserProfileSessionsUri(this.props.id)}>
                    <Button id="sessions-button1-profile" type="default" style={{ verticalAlign: 'bottom' }}>
                      {intl.get('sessions.title').d('Active sessions')}
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}

export default withRouter(UserProfileDisplay);
